/**
 * Shopify variant price can be a string ("5.00") or MoneyV2 ({ amount, currencyCode }).
 */
export function getVariantPriceAmount(price) {
  if (price == null || price === "") return null;

  if (typeof price === "number") {
    return Number.isFinite(price) ? price : null;
  }

  if (typeof price === "object") {
    const amount = price.amount ?? price.value ?? price;
    const parsed = Number(amount);
    return Number.isFinite(parsed) ? parsed : null;
  }

  const parsed = Number(String(price).replace(/[^0-9.-]/g, ""));
  return Number.isFinite(parsed) ? parsed : null;
}

export function formatVariantPrice(price, fallbackCurrency = "") {
  const amount = getVariantPriceAmount(price);
  if (amount == null) return "—";

  const currency =
    (typeof price === "object" && (price.currencyCode || price.currency)) ||
    fallbackCurrency ||
    "";

  return currency ? `${amount.toFixed(2)} ${currency}` : amount.toFixed(2);
}

export function hasValidVariantPrice(price) {
  const amount = getVariantPriceAmount(price);
  return amount != null && amount > 0;
}

export function getVariantIssues(variantNode = {}, productNode = {}) {
  const issues = [];
  const image =
    variantNode.image?.url ||
    variantNode.image?.src ||
    (typeof variantNode.image === "string" ? variantNode.image : "") ||
    productNode.image ||
    productNode.images?.edges?.[0]?.node?.url ||
    productNode.images?.edges?.[0]?.node?.src ||
    productNode.media?.nodes?.find((node) => node?.image?.url)?.image?.url ||
    "";

  if (!hasValidVariantPrice(variantNode.price)) {
    issues.push("Price is missing");
  }

  if (!image) {
    issues.push("Product image is missing");
  } else if (!String(image).startsWith("https://")) {
    issues.push("Product image must use HTTPS");
  }

  return issues;
}
